import styled from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  margin,
  MarginProps,
  typography,
  TypographyProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { TEXT_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import {
  LegacyCustomProps,
  textBoldCss,
  textJustifyCss,
  textLightCss,
  textLinkCss,
  textSecondaryCss,
  textSmallCss,
  textTitleCss,
  textUnderlineCss,
  textWhiteCss,
} from './_legacy'
import { centerCss, CustomAlignProps, leftCss, rightCss } from './align'
import {
  bodyCss,
  CustomColorProps,
  invertedBodyCss,
  invertedMutedCss,
  invertedTitleCss,
  linkColorCss,
  mutedCss,
  titleCss,
} from './color'
import {
  capitalizeCss,
  CustomExtendedProps,
  ellipsisCss,
  monospaceCss,
  nowrapCss,
  preWrapCss,
  uppercaseCss,
} from './extended'
import {
  body12Css,
  body14Css,
  body16Css,
  body20Css,
  caption12Css,
  CustomTypographyProps,
  title28Css,
  title40Css,
  title52Css,
} from './typography'
import { CustomWeightProps, mediumCss, semiLightCss } from './weight'

type AsProps = {
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div'
}

type CustomProps = CustomExtendedProps &
  CustomColorProps &
  CustomAlignProps &
  CustomTypographyProps &
  CustomWeightProps &
  LegacyCustomProps

type TextProps = AsProps &
  CustomProps &
  ColorProps &
  LayoutProps &
  MarginProps &
  TypographyProps

const shouldForwardProp = (prop: string | number) => {
  return !TEXT_SHOULD_FORWARD_PROP.includes(String(prop))
}

const Text = styled.p.withConfig({ shouldForwardProp })<TextProps>`
  margin: 0;
  padding: 0;
  color: ${themeGet('colors.text.body')};
  font-size: 20px;
  line-height: 1.6;
  letter-spacing: 0.05em;

  ${bodyCss}
  ${invertedBodyCss}
  ${invertedMutedCss}
  ${invertedTitleCss}
  ${linkColorCss}
  ${mutedCss}
  ${titleCss}

  ${mediumCss}
  ${semiLightCss}

  ${capitalizeCss}
  ${ellipsisCss}
  ${monospaceCss}
  ${nowrapCss}
  ${preWrapCss}
  ${uppercaseCss}

  ${body12Css}
  ${body14Css}
  ${body16Css}
  ${body20Css}
  ${caption12Css}
  ${title28Css}
  ${title40Css}
  ${title52Css}

  ${centerCss}
  ${leftCss}
  ${rightCss}

  ${layout}
  ${margin}
  ${color}
  ${typography}

  // Legacy
  ${textBoldCss}
  ${textJustifyCss}
  ${textLightCss}
  ${textLinkCss}
  ${textSecondaryCss}
  ${textSmallCss}
  ${textUnderlineCss}
  ${textWhiteCss}

  ${textTitleCss}
`

export default Text
